export const PUBLIC_SEO_PATHS = new Set([
  '/', '/web-core-vitals-google-report-crux', '/lab-insights', '/lab-test',
  '/quick-audit', '/quick-tools', '/monitoring', '/history-monitoring',
  '/rankings', '/top-performers', '/czech-webs-ranking',
  '/competitor-comparison', '/domain-comparison', '/global-insights', '/market-insights',
  '/ai-crawler-guide', '/platform-status', '/eshop-health-check',
  '/health-check', '/methodology', '/credits', '/terms', '/privacy', '/dpa',
  '/pricing',
]);

export function isPublicSeoPath(pathname) {
  return PUBLIC_SEO_PATHS.has(pathname) ||
    pathname === '/blog' ||
    pathname.startsWith('/blog/');
}

export function resolveInitialLanguage({ pathname, search, storedLanguage, browserLanguage }) {
  if (isPublicSeoPath(pathname)) {
    return new URLSearchParams(search).get('lang') === 'en' ? 'en' : 'cs';
  }
  if (storedLanguage === 'cs' || storedLanguage === 'en') return storedLanguage;
  const browserCode = browserLanguage?.split('-')[0];
  return browserCode === 'en' || browserCode === 'cs' ? browserCode : 'cs';
}

export function localizedPublicPath(path, language, origin = 'https://controlvitals.com') {
  const url = new URL(path, origin);
  if (language === 'en') url.searchParams.set('lang', 'en');
  else url.searchParams.delete('lang');
  return `${url.pathname}${url.search}${url.hash}`;
}

export function localizedArticlePath(article, language) {
  const slug = language === 'cs' ? (article.slugCs || article.slug) : article.slug;
  return localizedPublicPath(`/blog/${encodeURIComponent(slug)}`, language);
}